module.exports = __webpack_public_path__ + "img/symbol_0.bbaa4506.png";